import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoLg: CultureInfo = {
  name: 'lg',
  displayName: 'Luganda',
  iso3LanguageCode: 'lug',
  iso2LanguageCode: 'lg',
  ietfLanguageTag: 'lg',
  parent: null
};
